import Apis from '@/Apis/_'
import TipoDocumentoUpload from '../enum/TipoDocumentoUpload'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'
import { SolicitacaoCirurgia } from '../interfaces/SolicitacaoCirurgia'

class SolicitacaoCirurgiaImp extends CoreBase implements ISolicitacaoCirurgiaImp {
  async post(solicitacaoCirurgia: SolicitacaoCirurgia): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.post(solicitacaoCirurgia.medicoSolicitanteId, solicitacaoCirurgia)
    return response
  }

  async put(solicitacaoId: string, solicitacaoCirurgia: SolicitacaoCirurgia): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.put(solicitacaoId, solicitacaoCirurgia)
    return response
  }

  async get(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.get(solicitacaoId)
    return response
  }

  async finalizar(solicitacaoId: string) : Promise<ResponseApi> {
    const response = Apis.Agendamento.SolicitacaoCirurgiaApi.finalizar(solicitacaoId)
    return response
  }

  async getAllConvenio(hospitalId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllConvenio(hospitalId)
    return response
  }

  async getModeloCirurgia(hospitalId: string, medicoId: string, convenioId?: string, planoId?: string, localAtendimentoId?: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getModeloCirurgia(hospitalId, medicoId, convenioId, planoId, localAtendimentoId)
    return response
  }

  async getPacienteByHospital(hospitalId: string, query: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getPacienteByHospital(hospitalId, query)
    return response
  }

  async getAllLocalAtendimento(medicoId: string, hospitalId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLocalAtendimentoByMedico(medicoId, hospitalId)
    return response
  }

  async deleteProcedimentoPrincipal(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteProcedimentoPrincipal(solicitacaoId)
    return response
  }

  async getSolicitacaoProcedimentos(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getSolicitacaoProcedimentos(solicitacaoId)
    return response
  }

  async getOpmes(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getGrupoOpmeDaSolicitacao(solicitacaoId)
    return response
  }

  async getProcedimentoSearch(medicoSolicitanteId: string, hospitalId: string, convenioId: string, searchText: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getProcedimentoSearch(medicoSolicitanteId, hospitalId, convenioId, searchText)
    return response
  }

  async getEquipamentos(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getEquipamentos(solicitacaoId)
    return response
  }

  async getOpmeSearch(medicoSolicitanteId: String, searchText: String, procedimentos: string[], convenioId: String | null, hospitalId: String): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getOpmeSearch(medicoSolicitanteId, searchText, procedimentos, convenioId, hospitalId)
    return response
  }

  async getGrupoOpmeByMedico(hospitalId: string, medicoId: string, solicitacaoId: string, params: string[] = []): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getGrupoOpmeByMedico(hospitalId, medicoId, solicitacaoId, params)
    return response
  }

  async getMedicoOpme(hospitalId: string, medicoId: string, solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoOpme(hospitalId, medicoId, solicitacaoId)
    return response
  }

  async getGrupoOpmeDaSolicitacao(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getGrupoOpmeDaSolicitacao(solicitacaoId)
    return response
  }

  async createMedicoOpme(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.createMedicoOpme(params)
    return response
  }

  async createMedicoGrupoOpme(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.createMedicoGrupoOpme(params)
    return response
  }

  async deleteMedicoGrupoOpme(hospitalId: string, medicoId: string, grupoOpmeId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteMedicoGrupoOpme(hospitalId, medicoId, grupoOpmeId)
    return response
  }

  async upsertMedicoGrupoOpme(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.upsertMedicoGrupoOpme(params)
    return response
  }

  async deleteGrupoOpmeDaSolicitacao(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteGrupoOpmeDaSolicitacao(params)
    return response
  }

  async getAllFornecedor(hospitalId: string, convenioId: string, medicoId: string, solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllFornecedor(hospitalId, convenioId, medicoId, solicitacaoId)
    return response
  }

  async getEquipamentoSearch(hospitalId: String, searchText: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getEquipamentoSearch(hospitalId, searchText)
    return response
  }

  async getEquipamentoGrupoSearch(hospitalId: String, searchText: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getEquipamentoGrupoSearch(hospitalId, searchText)
    return response
  }

  async getAllGrupoEquipamentoParaOMedico(hospitalId: String, searchText: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getAllGrupoEquipamentoParaOMedico(hospitalId, searchText)
    return response
  }

  async getAllLaudos(solicitacaoId: String, tipoDocumento: TipoDocumentoUpload): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi
      .getAllLaudos(solicitacaoId, tipoDocumento)
    return response
  }

  async getAllInstrumentos(procedimentoIds: string[], hospitalId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllInstrumentos(procedimentoIds, hospitalId)
    return response
  }

  async getMedicoGradeDeHorario(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoGradeDeHorario(params)
    return response
  }

  async medicoInformaDataNaGradeDeHorarios(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.medicoInformaDataNaGradeDeHorarios(params)
    return response
  }

  async deleteGrupoEquipamento(solicitacaoId: string, equipamentoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteGrupoEquipamento(solicitacaoId, equipamentoId)
    return response
  }

  async postEquipamento(solicitacaoId: string, data: { grupoEquipamentoId: string, equipamentoId?: string }): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postEquipamento(solicitacaoId, data)
    return response
  }

  async getAllCategoriasByConvenio(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllCategoriasByConvenio(params)
    return response
  }

  async updateProcedimentoBySolicitacaoId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.updateProcedimentoBySolicitacaoId(params)
    return response
  }

  async deleteSolicitacao(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteSolicitacao(solicitacaoId)
    return response
  }

  async getAllCaixasCirurgicasByHospitalId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllCaixasCirurgicasByHospitalId(params)
    return response
  }

  async upsertCaixaCirurgicaBySolicitacaoId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.upsertCaixaCirurgicaBySolicitacaoId(params)
    return response
  }

  async deleteCaixaCirurgicaBySolicitacaoId(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteCaixaCirurgicaBySolicitacaoId(params)
    return response
  }

  async getAllAnestesistas(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllAnestesistas(params)
    return response
  }

  async postAnestesista(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.postAnestesista(params)
    return response
  }

  async adicionaPaciente(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.adicionaPaciente(params)
    return response
  }
}

interface ISolicitacaoCirurgiaImp extends ICoreBase {
  post(solicitacaoCirurgia: SolicitacaoCirurgia): Promise<ResponseApi>
  put(solicitacaoId: string, solicitacaoCirurgia: SolicitacaoCirurgia): Promise<ResponseApi>
  get(solicitacaoId: string): Promise<ResponseApi>
  finalizar(solicitacaoId: string): Promise<ResponseApi>
  getAllConvenio(hospitalId: string): Promise<ResponseApi>
  getModeloCirurgia(hospitalId: string, medicoId: string, convenioId?: string, planoId?: string, localAtendimentoId?: string): Promise<ResponseApi>
  getPacienteByHospital(hospitalId: string, query: any): Promise<ResponseApi>
  getAllLocalAtendimento(medicoId: string, hospitalId: string): Promise<ResponseApi>
  deleteProcedimentoPrincipal(solicitacaoId: string): Promise<ResponseApi>
  getSolicitacaoProcedimentos(solicitacaoId: string): Promise<ResponseApi>
  getOpmes(solicitacaoId: string): Promise<ResponseApi>
  getOpmeSearch(medicoSolicitanteId: String, searchText: String, procedimentos: string[], convenioId: String | null, hospitalId: String): Promise<ResponseApi>
  getGrupoOpmeByMedico(hospitalId: string, medicoId: string, solicitacaoId: string, params: string[]): Promise<ResponseApi>
  getMedicoOpme(hospitalId: string, medicoId: string, solicitacaoId: string): Promise<ResponseApi>
  getGrupoOpmeDaSolicitacao(solicitacaoId: string): Promise<ResponseApi>
  createMedicoOpme(params: any): Promise<ResponseApi>
  createMedicoGrupoOpme(params: any): Promise<ResponseApi>
  deleteMedicoGrupoOpme(hospitalId: string, medicoId: string, grupoOpmeId: string): Promise<ResponseApi>
  upsertMedicoGrupoOpme(params: any): Promise<ResponseApi>
  deleteGrupoOpmeDaSolicitacao(params: any): Promise<ResponseApi>
  getAllFornecedor(hospitalId: string, convenioId: string, medicoId: string, solicitacaoId: string): Promise<ResponseApi>
  getProcedimentoSearch(medicoSolicitanteId: string, hospitalId: string, convenioId: string | null, searchText: string): Promise<ResponseApi>
  getEquipamentos(solicitacaoId: string): Promise<ResponseApi>
  getEquipamentoSearch(hospitalId: String, searchText: string): Promise<ResponseApi>
  getEquipamentoGrupoSearch(hospitalId: String, searchText: string): Promise<ResponseApi>
  getAllGrupoEquipamentoParaOMedico(hospitalId: String, searchText: string): Promise<ResponseApi>
  getAllLaudos(solicitacaoId: String, tipoDocumento: TipoDocumentoUpload): Promise<ResponseApi>
  getAllInstrumentos(procedimentoIds: string[], hospitalId: String): Promise<ResponseApi>
  getMedicoGradeDeHorario(params: any): Promise<ResponseApi>
  medicoInformaDataNaGradeDeHorarios(params: any): Promise<ResponseApi>
  deleteGrupoEquipamento(solicitacaoId: string, equipamentoId: string): Promise<ResponseApi>
  postEquipamento(solicitacaoId: string, data: { grupoEquipamentoId: string, equipamentoId?: string }): Promise<ResponseApi>
  getAllCategoriasByConvenio(params: any): Promise<ResponseApi>
  updateProcedimentoBySolicitacaoId(params: any): Promise<ResponseApi>
  deleteSolicitacao(solicitacaoId: string): Promise<ResponseApi>
  getAllCaixasCirurgicasByHospitalId(params: any): Promise<ResponseApi>
  upsertCaixaCirurgicaBySolicitacaoId(params: any): Promise<ResponseApi>
  deleteCaixaCirurgicaBySolicitacaoId(params: any): Promise<ResponseApi>
  getAllAnestesistas(params: any): Promise<ResponseApi>
  postAnestesista(params: any): Promise<ResponseApi>
  adicionaPaciente(params: any): Promise<ResponseApi>
}

export {
  ISolicitacaoCirurgiaImp,
  SolicitacaoCirurgiaImp,
}
